/**
 * Quicklink "Meine Angebotsliste" im Header.
 *
 * Eigenes Miniskript, weil assets/mdzo-angebot.js nur auf der Produktseite und
 * auf der Angebotsliste geladen wird, der Header aber auf jeder Seite steht.
 * Geteilt sind nur der Storage-Key, das Ablaufdatum und der Event-Name. Die
 * Duplikation ist Absicht: fuer einen Link im Header das ganze Modul global zu
 * laden waere teurer als diese paar Zeilen.
 */
(() => {
  const STORAGE_KEY = 'mdzo-angebot-v1';
  const CHANGE_EVENT = 'mdzo-angebot:change';

  /**
   * Counts the positions in the stored list, treating an expired or unreadable
   * list as empty.
   * @returns {number} Number of positions.
   */
  function count() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return 0;

      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed.items)) return 0;
      if (parsed.expiresAt && Date.now() > parsed.expiresAt) return 0;

      return parsed.items.filter((item) => item && item.handle && item.variantId).length;
    } catch (e) {
      return 0;
    }
  }

  /**
   * @param {number} [known] - Count from the change event, saves a read.
   */
  function sync(known) {
    const total = typeof known === 'number' ? known : count();

    document.querySelectorAll('[data-mdzo-angebot-quicklink]').forEach((link) => {
      link.hidden = total === 0;
      const counter = link.querySelector('[data-mdzo-angebot-count]');
      // 20.09.2026: nur schreiben, wenn sich die Zahl aendert.
      if (counter && counter.textContent !== String(total)) counter.textContent = String(total);
    });
  }

  document.addEventListener(CHANGE_EVENT, (evt) => {
    const known = evt.detail && typeof evt.detail.count === 'number' ? evt.detail.count : undefined;
    sync(known);
  });

  // Zweiter Tab: dort geleerte Liste soll den Link hier nicht stehen lassen.
  window.addEventListener('storage', (evt) => {
    if (evt.key === STORAGE_KEY || evt.key === null) sync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sync());
  } else {
    sync();
  }
})();
